import { Directive, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { Store } from '@ngrx/store';

import * as fromStore from '@app/core/store';
import { Utils } from '@app/core';

@Directive({
  selector: '[permissions]',
})
export class PermissionsDirective {
  constructor(private _templateRef: TemplateRef<any>,
    private _viewContainer: ViewContainerRef,
    private store: Store<fromStore.State>) { }

  @Input() set permissions(allowedPermissions: Array<string>) {
    let hasPermission: boolean = true;


    if (allowedPermissions && allowedPermissions.length > 0) {
      let userPermissions: Array<string>;
      this.store.select(fromStore.selectLoggedInUserPermissions)
        .take(1)
        .subscribe(permissions => userPermissions = permissions);

      hasPermission = Utils.hasOneOfOrNoRestriction(userPermissions, allowedPermissions);
    }

    if (hasPermission) {
      this._viewContainer.createEmbeddedView(this._templateRef);
    } else {
      this._viewContainer.clear();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/directives/permissions.directive.ts